import { h, FunctionComponent } from "preact";
import { useData } from "../../data/react_hooks";
import { Gallery } from "../../gallery/gallery";
import { AppError, AppErrorType } from "../app_error";
import { Gallery as GalleryComponent } from "./gallery";

import css from "./gallery_controller.scss";

interface Props {
  galleryId?: string;
  selectedImageId?: string;
  showTitle?: boolean;
}

export const GalleryController: FunctionComponent<Props> = (props) => {
  const galleryData = useData(["gallery", props.galleryId!]);
  const showTitle = props.showTitle === undefined ?? true;

  if (!galleryData.exists) {
    throw new AppError(AppErrorType.PAGE_NOT_FOUND);
  }

  const gallery = galleryData.value as Gallery;
  let title;
  if (showTitle) {
    title = <h2>{gallery.title}</h2>;
  }
  return (
    <div class={css("container")}>
      {title}
      <GalleryComponent
        galleryId={gallery.id}
        selectedImageId={props.selectedImageId}
        tiles={gallery.tiles}
      />
      {
        // <pre>{JSON.stringify(galleryData, null, 2)}</pre>
      }
    </div>
  );
};
